import React, { ReactNode } from 'react';

import { Separator } from '../Separator';
import { Header, Wrapper } from './style';

type Props = {
  title: string | ReactNode;
  extraButton?: ReactNode;
  projectIdButton?: ReactNode;
};

const PageHeader = ({ title, extraButton, projectIdButton }: Props): JSX.Element => {
  return (
    <>
      <Wrapper>
        <Header>{title}</Header>
        {extraButton && extraButton}
        {projectIdButton || null}
      </Wrapper>
      <Separator margin="24px 0 48px" />
    </>
  );
};

export default PageHeader;
